import { StationAvatar } from '@app/components/base/stations/StationAvatar';
import { LTime } from '@app/components/date/LTime';
import { Station, TimeRange, toDateTimeStr } from '@mi-front/core';
import { DurationForRange } from '@mi-front/ui';
import { Box, Typography } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const noRangeSelectedMessage = defineMessage({
  id: 'fragments.form.header.noRangeSelected',
  defaultMessage: 'Sin rango seleccionado',
});

interface CreateFragmentFormHeaderProps {
  station: Station;
  /** Unix timestamp range (ms) of the logger stream selection */
  selection?: TimeRange<number> | null;
}

/** Header section of the create-fragment form with title and station/selection metadata. */
export function CreateFragmentFormHeader({ station, selection }: CreateFragmentFormHeaderProps) {
  const { $t } = useIntl();

  return (
    <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
      <Typography variant="h6" fontWeight={600}>
        {$t({ id: 'fragments.form.header', defaultMessage: 'Crear fragmento' })}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5 }}>
        <StationAvatar stationId={station.id} station={station} size={14} sx={{ flexShrink: 0 }} />
        <Typography
          variant="caption"
          color="text.secondary"
          component="div"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          <Box component="span">{station.name}</Box>
          {selection ? (
            <>
              <Box component="span" sx={{ opacity: 0.5 }}>
                ·
              </Box>
              <LTime value={toDateTimeStr(selection.from)} showSeconds />
              <Box component="span" sx={{ opacity: 0.5 }}>
                ·
              </Box>
              <DurationForRange
                from={toDateTimeStr(selection.from)}
                to={toDateTimeStr(selection.to)}
                unitDisplay="narrow"
              />
            </>
          ) : (
            <>
              <Box component="span" sx={{ opacity: 0.5 }}>
                ·
              </Box>
              <Box component="span" sx={{ color: 'warning.main', opacity: 0.7 }}>
                {$t(noRangeSelectedMessage)}
              </Box>
            </>
          )}
        </Typography>
      </Box>
    </Box>
  );
}
